"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

var _mixins = require("../mixins");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mixins = (0, _utils.combineMixins)(_mixins.displayMixin, _mixins.sizeWithMinMaxMixin, _mixins.flexMixin);
var Spacer = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterPropsFromPropTypes)(mixins.propTypes)
})(_templateObject(), mixins);
Spacer.displayName = 'Spacer';
var SpacerWithDocs = (0, _stencilReactDesc.describe)(Spacer).description('Adds blank space between other elements on the page.');
SpacerWithDocs.propTypes = (0, _objectSpread2.default)({}, mixins.describedPropTypes);
var _default = SpacerWithDocs;
exports.default = _default;